import { h } from "preact";
import { DayModel, dayNames, monthNames, range } from "./common";

export function SingleDayCalendar({ model }: { model: DayModel }) {
    const { date } = model;
    const name = dayNames[date.getDay()] + " " + (date.getDate()) + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
    return (
        <div class="calendar calendar-day">
            {
                // <h1>{name}</h1>
            }
            {
                range(24).map(hour => {
                    return (
                        <div>
                            <div class="hour">{hour}</div>
                            <div></div>
                        </div>
                    );
                })
            }
        </div>
    );
}
